import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_BASE = `${API_BASE_URL}/api/embedded-emissions`;

export const embeddedEmissionService = {
  getAll: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.source) params.append('source', filters.source);
    if (filters.verification_status) params.append('verification_status', filters.verification_status);
    const response = await axios.get(`${API_BASE}?${params}`);
    return response.data;
  },

  record: async (eLedgerId, data) => {
    const response = await axios.post(`${API_BASE}/${eLedgerId}`, data);
    return response.data;
  },

  getByLedger: async (eLedgerId, filters = {}) => {
    const params = new URLSearchParams();
    if (filters.source) params.append('source', filters.source);
    if (filters.verification_status) params.append('verification_status', filters.verification_status);
    const response = await axios.get(`${API_BASE}/${eLedgerId}?${params}`);
    return response.data;
  },

  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/detail/${id}`);
    return response.data;
  }
};

export default embeddedEmissionService;
